import { menuUserImg } from "assets/img";
import { Link } from "react-router-dom"
import { useAuth } from 'react-oidc-context';


const UserNav = () => {

   const auth = useAuth();

  return (
    <>
      {!auth.isAuthenticated ? (
        <div className="text-end">
          <Link
            type="button"
            to=""
            className="text-white"
            onClick={() => void auth.signinRedirect()}
          >
            Logg inn
          </Link>
        </div>
      ) : (
        <div className="dropdown text-end cc-nav-dropdown">
          <span
            className="d-block text-decoration-none dropdown-toggle text-white"
            id="dropdownUser1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span className="d-none d-lg-inline">{auth.user?.profile.given_name} {auth.user?.profile.family_name}</span>
            <img src={menuUserImg} alt=""></img>
          </span>
          <ul
            className="dropdown-menu text-small dropdown-menu-end shadow-sm"
            aria-labelledby="dropdownUser1"
          >
            <li>
              <Link className="dropdown-item" to="/account">
                Min bedrift
              </Link>
            </li>
            <li>
              <a className="dropdown-item" href="https://min.1881.no/vilkaar-personvern/avtalevilkar-annonsering" rel="noreferrer" target="_blank">Avtalevilkår annonsering</a></li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <li>
              <a className="dropdown-item" href="https://min.1881.no">Min side</a>
            </li>
            <li><a className="dropdown-item" href="https://min.1881.no/vilkaar-personvern/personvernerklaring">Personvern</a></li>
            <li><button className="uc-embed-link dropdown-item" uc-data="all">Cookies</button></li>
            <li><a className="dropdown-item" href="https://kundeservice.1881.no">Kundeservice</a></li>
            <li>
              <Link className="dropdown-item" to="" onClick={()=>{void auth.signoutRedirect()}}>
                Logg ut
              </Link>
            </li>
          </ul>
        </div>
      )}
    </>
  )
}

export default UserNav